/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "./request";
const mockUrl_0_0_0_0 = "http://yapi.yishou.com/mock/128";
const devUrl_0_0_0_0 = "http://erp38.yishou.com/";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 [保存供应商邀约规则↗](http://yapi.yishou.com/project/128/interface/api/33869) 的 **请求配置**
 *
 * @分类 [前置仓邀约池↗](http://yapi.yishou.com/project/128/interface/api/cat_3350)
 * @标签 `爆版4.27`
 * @请求头 `POST /erp/PreStorageInviteRule/saveInvitationRule`
 */
const saveInvitationRuleRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/PreStorageInviteRule/saveInvitationRule",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        $schema: "http://json-schema.org/draft-04/schema#",
        type: "object",
        properties: {
            supply_id: { type: "number" },
            rule: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        id: { type: "number" },
                        invitation_category: { type: "string" },
                        forecast_days: { type: "number" },
                        psp_ir_status: { type: "number" },
                    },
                },
            },
        },
    },
    responseDataJsonSchema: { type: "string" },
    requestFunctionName: "saveInvitationRule",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [保存供应商邀约规则↗](http://yapi.yishou.com/project/128/interface/api/33869) 的 **请求函数**
 *
 * @分类 [前置仓邀约池↗](http://yapi.yishou.com/project/128/interface/api/cat_3350)
 * @标签 `爆版4.27`
 * @请求头 `POST /erp/PreStorageInviteRule/saveInvitationRule`
 */
export const saveInvitationRule = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(saveInvitationRuleRequestConfig, requestData), ...args);
};
saveInvitationRule.requestConfig = saveInvitationRuleRequestConfig;
/**
 * 接口 [获取供应商邀约规则↗](http://yapi.yishou.com/project/128/interface/api/33872) 的 **请求配置**
 *
 * @分类 [前置仓邀约池↗](http://yapi.yishou.com/project/128/interface/api/cat_3350)
 * @标签 `爆版4.27`
 * @请求头 `POST /erp/PreStorageInviteRule/getInvitationRule`
 */
const getInvitationRuleRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/PreStorageInviteRule/getInvitationRule",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        $schema: "http://json-schema.org/draft-04/schema#",
        type: "object",
        properties: { supply_id: { type: "string" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            rule: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        id: { type: "number" },
                        forecast_days: { type: "string" },
                        invitation_category: { type: "string" },
                        psp_ir_status: { type: "string" },
                        psp_ir_status_text: { type: "string" },
                    },
                },
            },
            category: {
                type: "array",
                items: {
                    type: "object",
                    properties: { label: { type: "string" }, value: { type: "string" } },
                    required: ["label", "value"],
                },
            },
            forecastDay: {
                type: "array",
                items: {
                    type: "object",
                    properties: { label: { type: "number" }, value: { type: "number" } },
                    required: ["label", "value"],
                },
            },
        },
    },
    requestFunctionName: "getInvitationRule",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取供应商邀约规则↗](http://yapi.yishou.com/project/128/interface/api/33872) 的 **请求函数**
 *
 * @分类 [前置仓邀约池↗](http://yapi.yishou.com/project/128/interface/api/cat_3350)
 * @标签 `爆版4.27`
 * @请求头 `POST /erp/PreStorageInviteRule/getInvitationRule`
 */
export const getInvitationRule = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getInvitationRuleRequestConfig, requestData), ...args);
};
getInvitationRule.requestConfig = getInvitationRuleRequestConfig;
/**
 * 接口 [前置仓邀约池列表↗](http://yapi.yishou.com/project/128/interface/api/33885) 的 **请求配置**
 *
 * @分类 [前置仓邀约池↗](http://yapi.yishou.com/project/128/interface/api/cat_3350)
 * @标签 `爆版4.27`
 * @请求头 `POST /erp/PreStorageInvitePool/getList`
 */
const getListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/PreStorageInvitePool/getList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["supply_name", "city", "market_id", "is_excel", "page", "pagesize"],
        properties: {
            supply_id: { type: "string", description: "商家ID" },
            supply_name: { type: "string", description: "商家名称（支持模糊匹配）" },
            city: { type: "string", description: "城市ID" },
            market_id: { type: "string", description: "市场ID" },
            is_excel: { type: "string", description: "是否导出列表{0:否,1:是}" },
            page: { type: "string", description: "页码" },
            pagesize: { type: "string", description: "每页展示行数" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            total: { type: "number", tag: "爆版4.27", description: "总条数" },
            page: { type: "number", tag: "爆版4.27", description: "页码" },
            file: { type: "string", description: "导出列表时，返回此字段" },
            list: {
                type: "object",
                properties: {
                    id: { type: "number" },
                    market_id: { type: "number", description: "市场ID" },
                    market_name: { type: "string", description: "市场名称" },
                    city: { type: "number", description: "城市ID" },
                    city_name: { type: "string", description: "城市名称" },
                    supply_id: { type: "number", description: "供应商ID" },
                    supply_name: { type: "string", description: "供应商名称" },
                    updated_at: { type: "string", description: "更新时间" },
                    created_at: { type: "string", description: "创建时间" },
                    to_order_num: { type: "number", description: "待开单数量" },
                    to_goods_num: { type: "number", description: "款数" },
                    to_order_price: { type: "number", description: "待开单总价格" },
                },
                required: [
                    "id",
                    "updated_at",
                    "supply_name",
                    "supply_id",
                    "city_name",
                    "city",
                    "market_name",
                    "market_id",
                    "to_order_price",
                    "to_goods_num",
                    "to_order_num",
                    "created_at",
                ],
            },
        },
        required: ["total", "page", "list", "file"],
        tag: "爆版4.27",
    },
    requestFunctionName: "getList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [前置仓邀约池列表↗](http://yapi.yishou.com/project/128/interface/api/33885) 的 **请求函数**
 *
 * @分类 [前置仓邀约池↗](http://yapi.yishou.com/project/128/interface/api/cat_3350)
 * @标签 `爆版4.27`
 * @请求头 `POST /erp/PreStorageInvitePool/getList`
 */
export const getList = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getListRequestConfig, requestData), ...args);
};
getList.requestConfig = getListRequestConfig;
/**
 * 接口 [前置仓邀约池列表明细导出↗](http://yapi.yishou.com/project/128/interface/api/33921) 的 **请求配置**
 *
 * @分类 [前置仓邀约池↗](http://yapi.yishou.com/project/128/interface/api/cat_3350)
 * @标签 `爆版4.27`
 * @请求头 `POST /erp/PreStorageInvitePool/exportInvitePoolDetail`
 */
const exportInvitePoolDetailRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/PreStorageInvitePool/exportInvitePoolDetail",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["supply_name", "city", "market_id", "page"],
        properties: {
            supply_id: { type: "string", description: "商家ID" },
            supply_name: { type: "string", description: "商家名称（支持模糊匹配）" },
            city: { type: "string", description: "城市ID" },
            market_id: { type: "string", description: "市场ID" },
            page: { type: "string", description: "页码" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: { file: { type: "string", description: "导出列表时，返回此字段" } },
        required: ["file"],
        tag: "爆版4.27",
    },
    requestFunctionName: "exportInvitePoolDetail",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [前置仓邀约池列表明细导出↗](http://yapi.yishou.com/project/128/interface/api/33921) 的 **请求函数**
 *
 * @分类 [前置仓邀约池↗](http://yapi.yishou.com/project/128/interface/api/cat_3350)
 * @标签 `爆版4.27`
 * @请求头 `POST /erp/PreStorageInvitePool/exportInvitePoolDetail`
 */
export const exportInvitePoolDetail = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(exportInvitePoolDetailRequestConfig, requestData), ...args);
};
exportInvitePoolDetail.requestConfig = exportInvitePoolDetailRequestConfig;
/**
 * 接口 [前置仓邀约池详情↗](http://yapi.yishou.com/project/128/interface/api/33922) 的 **请求配置**
 *
 * @分类 [前置仓邀约池↗](http://yapi.yishou.com/project/128/interface/api/cat_3350)
 * @标签 `爆版4.27`
 * @请求头 `POST /erp/PreStorageInvitePool/getInvItePoolDetail`
 */
const getInvItePoolDetailRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/PreStorageInvitePool/getInvItePoolDetail",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["goods_no", "goods_kh", "id", "page", "pagesize"],
        properties: {
            goods_name: { type: "string", description: "商品名称" },
            goods_no: { type: "string", description: "货号" },
            goods_kh: { type: "string", description: "款号" },
            id: { type: "string", description: "邀约池ID" },
            page: { type: "string", description: "页码" },
            pagesize: { type: "string", description: "每页展示条数" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            count: { type: "number", description: "总条数" },
            list: {
                type: "object",
                properties: {
                    plan_price: { type: "number", description: "计划采购价" },
                    img: { type: "string", description: "商品图片" },
                    id: { type: "number", description: "邀约池详情ID" },
                    supply_id: { type: "number", description: "商家ID" },
                    goods_no: { type: "string", description: "货号" },
                    sku: { type: "string", description: "sku" },
                    co_val: { type: "string", description: "颜色" },
                    si_val: { type: "string", description: "尺码" },
                    invitation_category: { type: "string", description: "商品分类" },
                    forecast_days: { type: "number", description: "预测天数" },
                    invitation_num: { type: "number", description: "邀约数量" },
                    invitation_price: { type: "number", description: "邀约价格" },
                    goods_name: { type: "string", description: "商品名称" },
                    goods_img: { type: "string" },
                    selected_number: { type: "number", description: "已选数量" },
                    goods_label: { type: "number", description: "入仓标签{1:备货,2:赠品,3:特价,4:商家自荐}" },
                },
                required: [
                    "plan_price",
                    "invitation_price",
                    "invitation_num",
                    "forecast_days",
                    "invitation_category",
                    "si_val",
                    "co_val",
                    "sku",
                    "goods_no",
                    "supply_id",
                    "id",
                    "img",
                    "goods_img",
                    "goods_name",
                    "goods_label",
                    "selected_number",
                ],
            },
            page: { type: "string", description: "页码" },
        },
        required: ["count", "list", "page"],
        tag: "爆版4.27",
    },
    requestFunctionName: "getInvItePoolDetail",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [前置仓邀约池详情↗](http://yapi.yishou.com/project/128/interface/api/33922) 的 **请求函数**
 *
 * @分类 [前置仓邀约池↗](http://yapi.yishou.com/project/128/interface/api/cat_3350)
 * @标签 `爆版4.27`
 * @请求头 `POST /erp/PreStorageInvitePool/getInvItePoolDetail`
 */
export const getInvItePoolDetail = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getInvItePoolDetailRequestConfig, requestData), ...args);
};
getInvItePoolDetail.requestConfig = getInvItePoolDetailRequestConfig;
/**
 * 接口 [前置仓邀约池详情统计数据↗](http://yapi.yishou.com/project/128/interface/api/33923) 的 **请求配置**
 *
 * @分类 [前置仓邀约池↗](http://yapi.yishou.com/project/128/interface/api/cat_3350)
 * @标签 `爆版4.27`
 * @请求头 `POST /erp/PreStorageInvitePool/getInvItePoolDetailInfo`
 */
const getInvItePoolDetailInfoRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/PreStorageInvitePool/getInvItePoolDetailInfo",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["id"],
        properties: { id: { type: "string", description: "邀约池ID" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            info: {
                type: "object",
                properties: {
                    supply_id: { type: "number", description: "商家ID" },
                    supply_name: { type: "string", description: "商家名称" },
                    updated_at: { type: "string", description: "更新时间" },
                    to_order_num: { type: "number", description: "总待开单数量" },
                    to_order_price: { type: "number", description: "邀约池总金额" },
                    to_goods_num: { type: "number", description: "款数" },
                    to_plan_price: { type: "number", description: "计划采购总价" },
                },
                required: [
                    "supply_id",
                    "to_goods_num",
                    "to_order_price",
                    "to_order_num",
                    "updated_at",
                    "supply_name",
                    "to_plan_price",
                ],
                tag: "爆版4.27",
            },
        },
        required: ["info"],
        tag: "爆版4.27",
    },
    requestFunctionName: "getInvItePoolDetailInfo",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [前置仓邀约池详情统计数据↗](http://yapi.yishou.com/project/128/interface/api/33923) 的 **请求函数**
 *
 * @分类 [前置仓邀约池↗](http://yapi.yishou.com/project/128/interface/api/cat_3350)
 * @标签 `爆版4.27`
 * @请求头 `POST /erp/PreStorageInvitePool/getInvItePoolDetailInfo`
 */
export const getInvItePoolDetailInfo = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getInvItePoolDetailInfoRequestConfig, requestData), ...args);
};
getInvItePoolDetailInfo.requestConfig = getInvItePoolDetailInfoRequestConfig;
/**
 * 接口 [前置仓邀约池详情汇总-缓存↗](http://yapi.yishou.com/project/128/interface/api/33927) 的 **请求配置**
 *
 * @分类 [前置仓邀约池↗](http://yapi.yishou.com/project/128/interface/api/cat_3350)
 * @标签 `爆版4.27`
 * @请求头 `POST /erp/PreStorageInvitePool/getInvItePoolDetailCollect`
 */
const getInvItePoolDetailCollectRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/PreStorageInvitePool/getInvItePoolDetailCollect",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["id"],
        properties: { id: { type: "string", description: "邀约池ID" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            total_goods_num: { type: "number", description: "总款数" },
            total_num: { type: "string", description: "总件数" },
            total_price: { type: "string", description: "总金额" },
        },
        tag: "爆版4.27",
        required: ["total_goods_num", "total_price", "total_num"],
    },
    requestFunctionName: "getInvItePoolDetailCollect",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [前置仓邀约池详情汇总-缓存↗](http://yapi.yishou.com/project/128/interface/api/33927) 的 **请求函数**
 *
 * @分类 [前置仓邀约池↗](http://yapi.yishou.com/project/128/interface/api/cat_3350)
 * @标签 `爆版4.27`
 * @请求头 `POST /erp/PreStorageInvitePool/getInvItePoolDetailCollect`
 */
export const getInvItePoolDetailCollect = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getInvItePoolDetailCollectRequestConfig, requestData), ...args);
};
getInvItePoolDetailCollect.requestConfig = getInvItePoolDetailCollectRequestConfig;
/**
 * 接口 [前置仓邀约池详情-保存缓存数据-ERP↗](http://yapi.yishou.com/project/128/interface/api/33932) 的 **请求配置**
 *
 * @分类 [前置仓邀约池↗](http://yapi.yishou.com/project/128/interface/api/cat_3350)
 * @标签 `爆版4.27`
 * @请求头 `POST /erp/PreStorageInvitePool/saveInvItePoolDetailCache`
 */
const saveInvItePoolDetailCacheRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/PreStorageInvitePool/saveInvItePoolDetailCache",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["id", "info"],
        properties: {
            id: { type: "string", description: "邀约池ID" },
            info: { type: "string", description: "需要保存的缓存数据信息（json格式，一个sku为一条数据）" },
        },
    },
    responseDataJsonSchema: { type: "object", properties: {}, tag: "爆版4.27" },
    requestFunctionName: "saveInvItePoolDetailCache",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [前置仓邀约池详情-保存缓存数据-ERP↗](http://yapi.yishou.com/project/128/interface/api/33932) 的 **请求函数**
 *
 * @分类 [前置仓邀约池↗](http://yapi.yishou.com/project/128/interface/api/cat_3350)
 * @标签 `爆版4.27`
 * @请求头 `POST /erp/PreStorageInvitePool/saveInvItePoolDetailCache`
 */
export const saveInvItePoolDetailCache = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(saveInvItePoolDetailCacheRequestConfig, requestData), ...args);
};
saveInvItePoolDetailCache.requestConfig = saveInvItePoolDetailCacheRequestConfig;
/**
 * 接口 [前置仓邀约池详情-开单↗](http://yapi.yishou.com/project/128/interface/api/33942) 的 **请求配置**
 *
 * @分类 [前置仓邀约池↗](http://yapi.yishou.com/project/128/interface/api/cat_3350)
 * @标签 `爆版4.27`
 * @请求头 `POST /erp/PreStorageInvitePool/createPrePlan`
 */
const createPrePlanRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/PreStorageInvitePool/createPrePlan",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["id", "plan_method", "return_day"],
        properties: {
            id: { type: "string", description: "邀约池ID" },
            plan_method: { type: "string", description: "开单方式{1:实数单,2:排单单}" },
            return_day: { type: "string", description: "承诺回货时间" },
        },
    },
    responseDataJsonSchema: { type: "object", properties: {}, tag: "爆版4.27" },
    requestFunctionName: "createPrePlan",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [前置仓邀约池详情-开单↗](http://yapi.yishou.com/project/128/interface/api/33942) 的 **请求函数**
 *
 * @分类 [前置仓邀约池↗](http://yapi.yishou.com/project/128/interface/api/cat_3350)
 * @标签 `爆版4.27`
 * @请求头 `POST /erp/PreStorageInvitePool/createPrePlan`
 */
export const createPrePlan = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(createPrePlanRequestConfig, requestData), ...args);
};
createPrePlan.requestConfig = createPrePlanRequestConfig;
/**
 * 接口 [获取采购员↗](http://yapi.yishou.com/project/128/interface/api/33943) 的 **请求配置**
 *
 * @分类 [前置仓邀约池↗](http://yapi.yishou.com/project/128/interface/api/cat_3350)
 * @标签 `爆版4.27`
 * @请求头 `POST /erp/PreStorageInvitePool/preStoragePoolSelectPurchase`
 */
const preStoragePoolSelectPurchaseRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/PreStorageInvitePool/preStoragePoolSelectPurchase",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        $schema: "http://json-schema.org/draft-04/schema#",
        type: "object",
        properties: { supply_name: { type: "string", description: "供应商名称" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            supply_id: { type: "string", description: "供应商id", tag: "爆版4.27" },
            pg_name: { type: "string", description: "采购组名称", tag: "爆版4.27" },
            pg_member_name: { type: "string", description: "采购员名称", tag: "爆版4.27" },
        },
    },
    requestFunctionName: "preStoragePoolSelectPurchase",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取采购员↗](http://yapi.yishou.com/project/128/interface/api/33943) 的 **请求函数**
 *
 * @分类 [前置仓邀约池↗](http://yapi.yishou.com/project/128/interface/api/cat_3350)
 * @标签 `爆版4.27`
 * @请求头 `POST /erp/PreStorageInvitePool/preStoragePoolSelectPurchase`
 */
export const preStoragePoolSelectPurchase = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(preStoragePoolSelectPurchaseRequestConfig, requestData), ...args);
};
preStoragePoolSelectPurchase.requestConfig = preStoragePoolSelectPurchaseRequestConfig;
/**
 * 接口 [获取手动邀约可选择商品↗](http://yapi.yishou.com/project/128/interface/api/33944) 的 **请求配置**
 *
 * @分类 [前置仓邀约池↗](http://yapi.yishou.com/project/128/interface/api/cat_3350)
 * @标签 `爆版4.27`
 * @请求头 `POST /erp/PreStorageInvitePool/preStoragePoolSelectGoods`
 */
const preStoragePoolSelectGoodsRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/PreStorageInvitePool/preStoragePoolSelectGoods",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        $schema: "http://json-schema.org/draft-04/schema#",
        type: "object",
        properties: {
            supply_name: { type: "string", description: "供应商名称" },
            goods_status: { type: "array", items: { type: "number" }, description: "商品状态" },
            page: { type: "number", description: "分页页数" },
            goods_name: { type: "string", description: "商品名称" },
            goods_no: { type: "string", description: "商品货号" },
            goods_kh: { type: "string", description: "商品款号" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            total: { type: "number" },
            per_page: { type: "number" },
            current_page: { type: "string" },
            last_page: { type: "number" },
            data: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        goods_no: { type: "string", description: "货号" },
                        goods_kh: { type: "string", description: "款号" },
                        goods_name: { type: "string", description: "商品名称" },
                        goods_img: { type: "string" },
                        market_price: { type: "string", description: "市场价格" },
                        is_gift: { type: "string" },
                        brand_name: { type: "string", description: "品牌名称" },
                        goods_status: { type: "string", description: "'商品状态{1:正常,2:断货}'" },
                        is_on_sale: { type: "string", description: "是否上架销售{1:上架,0:下架}" },
                        add_time: { type: "string" },
                        main_img: { type: "string", description: "主图" },
                        middle_img: { type: "array", items: { type: "string" } },
                        optional: { type: "number" },
                        optional_msg: { type: "string" },
                        is_advice: { type: "number" },
                        advice_days: { type: "array", items: { type: "string" } },
                        sku_data: {
                            type: "array",
                            items: {
                                type: "object",
                                properties: {
                                    goods_no: { type: "string", description: "商品货号" },
                                    plan_price: { type: "string", description: "采购价" },
                                    co_id: { type: "string" },
                                    co_val: { type: "string", description: "颜色" },
                                    si_id: { type: "string" },
                                    si_val: { type: "string", description: "尺码" },
                                    sku: { type: "string", description: "sku信息" },
                                    advice_num: { type: "array", items: { type: "number" } },
                                },
                                required: ["goods_no", "plan_price", "co_id", "co_val", "si_id", "si_val", "sku", "advice_num"],
                            },
                        },
                    },
                    required: [
                        "goods_no",
                        "goods_kh",
                        "goods_name",
                        "goods_img",
                        "market_price",
                        "is_gift",
                        "brand_name",
                        "goods_status",
                        "is_on_sale",
                        "add_time",
                        "main_img",
                        "middle_img",
                        "optional",
                        "optional_msg",
                        "is_advice",
                        "advice_days",
                        "sku_data",
                    ],
                },
                tag: "爆版4.27",
            },
        },
        tag: "爆版4.27",
    },
    requestFunctionName: "preStoragePoolSelectGoods",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取手动邀约可选择商品↗](http://yapi.yishou.com/project/128/interface/api/33944) 的 **请求函数**
 *
 * @分类 [前置仓邀约池↗](http://yapi.yishou.com/project/128/interface/api/cat_3350)
 * @标签 `爆版4.27`
 * @请求头 `POST /erp/PreStorageInvitePool/preStoragePoolSelectGoods`
 */
export const preStoragePoolSelectGoods = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(preStoragePoolSelectGoodsRequestConfig, requestData), ...args);
};
preStoragePoolSelectGoods.requestConfig = preStoragePoolSelectGoodsRequestConfig;
/**
 * 接口 [手动邀约添加到邀约池中↗](http://yapi.yishou.com/project/128/interface/api/33945) 的 **请求配置**
 *
 * @分类 [前置仓邀约池↗](http://yapi.yishou.com/project/128/interface/api/cat_3350)
 * @标签 `爆版4.27`
 * @请求头 `POST /erp/PreStorageInvitePool/saveInvitePoolGoods`
 */
const saveInvitePoolGoodsRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/PreStorageInvitePool/saveInvitePoolGoods",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        $schema: "http://json-schema.org/draft-04/schema#",
        type: "object",
        properties: {
            supply_id: { type: "string" },
            goods_detail: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        goods_no: { type: "number", description: "商品货号" },
                        co_id: { type: "number", description: "颜色id" },
                        si_id: { type: "number", description: "尺码id" },
                        plan_price: { type: "string", description: "计划价格" },
                        recommend_stocking_num: { type: "number", description: "邀约数量" },
                        sku: { type: "number", description: "sku id" },
                    },
                },
            },
        },
    },
    responseDataJsonSchema: { type: "string" },
    requestFunctionName: "saveInvitePoolGoods",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [手动邀约添加到邀约池中↗](http://yapi.yishou.com/project/128/interface/api/33945) 的 **请求函数**
 *
 * @分类 [前置仓邀约池↗](http://yapi.yishou.com/project/128/interface/api/cat_3350)
 * @标签 `爆版4.27`
 * @请求头 `POST /erp/PreStorageInvitePool/saveInvitePoolGoods`
 */
export const saveInvitePoolGoods = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(saveInvitePoolGoodsRequestConfig, requestData), ...args);
};
saveInvitePoolGoods.requestConfig = saveInvitePoolGoodsRequestConfig;
/**
 * 接口 [前置仓邀约池详情-重置↗](http://yapi.yishou.com/project/128/interface/api/33946) 的 **请求配置**
 *
 * @分类 [前置仓邀约池↗](http://yapi.yishou.com/project/128/interface/api/cat_3350)
 * @标签 `爆版4.27`
 * @请求头 `POST /erp/PreStorageInvitePool/clearCache`
 */
const clearCacheRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/PreStorageInvitePool/clearCache",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["id"],
        properties: { id: { type: "string", description: "邀约池ID" } },
    },
    responseDataJsonSchema: { type: "object", properties: {}, tag: "爆版4.27" },
    requestFunctionName: "clearCache",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [前置仓邀约池详情-重置↗](http://yapi.yishou.com/project/128/interface/api/33946) 的 **请求函数**
 *
 * @分类 [前置仓邀约池↗](http://yapi.yishou.com/project/128/interface/api/cat_3350)
 * @标签 `爆版4.27`
 * @请求头 `POST /erp/PreStorageInvitePool/clearCache`
 */
export const clearCache = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(clearCacheRequestConfig, requestData), ...args);
};
clearCache.requestConfig = clearCacheRequestConfig;
/**
 * 接口 [导入邀约商品↗](http://yapi.yishou.com/project/128/interface/api/33947) 的 **请求配置**
 *
 * @分类 [前置仓邀约池↗](http://yapi.yishou.com/project/128/interface/api/cat_3350)
 * @请求头 `POST /erp/PreStorageInvitePool/batchSaveInvitePoolGoods`
 */
const batchSaveInvitePoolGoodsRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/PreStorageInvitePool/batchSaveInvitePoolGoods",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["excel"],
        properties: { excel: { type: "file", description: "文件", tsType: "FileData" } },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "batchSaveInvitePoolGoods",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [导入邀约商品↗](http://yapi.yishou.com/project/128/interface/api/33947) 的 **请求函数**
 *
 * @分类 [前置仓邀约池↗](http://yapi.yishou.com/project/128/interface/api/cat_3350)
 * @请求头 `POST /erp/PreStorageInvitePool/batchSaveInvitePoolGoods`
 */
export const batchSaveInvitePoolGoods = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(batchSaveInvitePoolGoodsRequestConfig, requestData), ...args);
};
batchSaveInvitePoolGoods.requestConfig = batchSaveInvitePoolGoodsRequestConfig;
/**
 * 接口 [前置仓邀约池详情-全选↗](http://yapi.yishou.com/project/128/interface/api/33948) 的 **请求配置**
 *
 * @分类 [前置仓邀约池↗](http://yapi.yishou.com/project/128/interface/api/cat_3350)
 * @标签 `爆版4.27`
 * @请求头 `POST /erp/PreStorageInvitePool/saveInvIteAllCache`
 */
const saveInvIteAllCacheRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/PreStorageInvitePool/saveInvIteAllCache",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["id"],
        properties: { id: { type: "string", description: "邀约池ID" } },
    },
    responseDataJsonSchema: { type: "object", properties: {}, tag: "爆版4.27" },
    requestFunctionName: "saveInvIteAllCache",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [前置仓邀约池详情-全选↗](http://yapi.yishou.com/project/128/interface/api/33948) 的 **请求函数**
 *
 * @分类 [前置仓邀约池↗](http://yapi.yishou.com/project/128/interface/api/cat_3350)
 * @标签 `爆版4.27`
 * @请求头 `POST /erp/PreStorageInvitePool/saveInvIteAllCache`
 */
export const saveInvIteAllCache = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(saveInvIteAllCacheRequestConfig, requestData), ...args);
};
saveInvIteAllCache.requestConfig = saveInvIteAllCacheRequestConfig;
/**
 * 接口 [前置仓邀约池列表明细导出统计分页↗](http://yapi.yishou.com/project/128/interface/api/33977) 的 **请求配置**
 *
 * @分类 [前置仓邀约池↗](http://yapi.yishou.com/project/128/interface/api/cat_3350)
 * @标签 `爆版4.27`
 * @请求头 `POST /erp/PreStorageInvitePool/exportInvitePoolDetailTotal`
 */
const exportInvitePoolDetailTotalRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/PreStorageInvitePool/exportInvitePoolDetailTotal",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["supply_name", "city", "market_id"],
        properties: {
            supply_id: { type: "string", description: "商家ID" },
            supply_name: { type: "string", description: "商家名称（支持模糊匹配）" },
            city: { type: "string", description: "城市ID" },
            market_id: { type: "string", description: "市场ID" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: { page_data: { type: "string", description: '导出数据分页数据["1"=>1,"2"=>2]' } },
        required: ["page_data"],
        tag: "爆版4.27",
    },
    requestFunctionName: "exportInvitePoolDetailTotal",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [前置仓邀约池列表明细导出统计分页↗](http://yapi.yishou.com/project/128/interface/api/33977) 的 **请求函数**
 *
 * @分类 [前置仓邀约池↗](http://yapi.yishou.com/project/128/interface/api/cat_3350)
 * @标签 `爆版4.27`
 * @请求头 `POST /erp/PreStorageInvitePool/exportInvitePoolDetailTotal`
 */
export const exportInvitePoolDetailTotal = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(exportInvitePoolDetailTotalRequestConfig, requestData), ...args);
};
exportInvitePoolDetailTotal.requestConfig = exportInvitePoolDetailTotalRequestConfig;
/**
 * 接口 [供应商待办↗](http://yapi.yishou.com/project/128/interface/api/33988) 的 **请求配置**
 *
 * @分类 [前置仓邀约池↗](http://yapi.yishou.com/project/128/interface/api/cat_3350)
 * @标签 `爆版4.28.0`
 * @请求头 `POST /baob/SupplyNotice/getWaitDealList`
 */
const getWaitDealListRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baob/SupplyNotice/getWaitDealList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: { type: "object", required: [], properties: {} },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            wait_deal: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        title: { type: "string", description: '"请及时填写SKU编码"' },
                        content: { type: "string", description: '"您的店铺有172款商品未填写SKU编码"' },
                        action: { type: "string", description: '"goods_lib_list_no_sku"' },
                        is_read: { type: "integer" },
                        publish_time: { type: "string", description: '"22/12/15"' },
                        img_url: { type: "string" },
                        extra_param: { type: "object" },
                    },
                    additionalProperties: false,
                },
                description: '[{"title":"请及时填写SKU编码","content":"您的店铺有172款商品未填写SKU编码","action":"goods_lib_list_no_sku","is_read":0,"publish_time":"22/12/15","img_url":"","extra_param":{}},{"title":"填写货期通知","content":"您的一手店铺共721款商品没有货期;共1款商品承诺库存即将售罄","action":"schedule","is_read":0,"publish_time":"22/08/08","img_url":"","extra_param":{}},{"title":"免审IIII待签署","content":"请确认并签署免审IIII","action":"sign_contract","publish_time":"22/08/08","is_read":0,"img_url":"","extra_param":{"sc_id":"66"},"prohibit_click_toast":"无权限处理合同，请通知老板处理"},{"title":"免审II待签署","content":"请确认并签署免审II","action":"sign_contract","publish_time":"22/08/08","is_read":0,"img_url":"","extra_param":{"sc_id":"68"},"prohibit_click_toast":"无权限处理合同，请通知老板处理"},{"title":"部分前置仓商品滞销，请及时调整价格","content":"共5款商品44件库存需要降价出售","action":"unsalable_goods","is_read":0,"publish_time":"22/08/08","img_url":"","extra_param":[]},{"title":"您有让利账单待确认","content":"请点击浏览详情并进行确认","action":"confirm_return_profit_bill","publish_time":"22/09/08","is_read":0,"img_url":"","extra_param":{"bill_id":"4"}},{"title":"您有让利账单待支付","content":"请点击浏览详情并进行支付","action":"pay_return_profit_bill","publish_time":"22/09/08","is_read":0,"img_url":"","extra_param":{"bill_id":"3"}},{"title":"您的投诉已处理回复","content":"请点击浏览详情及进行评分","action":"complaint","is_read":0,"publish_time":"22/09/03","img_url":"","extra_param":{"complaint_id":3}}]',
            },
            is_boss: { type: "integer" },
        },
        additionalProperties: false,
    },
    requestFunctionName: "getWaitDealList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [供应商待办↗](http://yapi.yishou.com/project/128/interface/api/33988) 的 **请求函数**
 *
 * @分类 [前置仓邀约池↗](http://yapi.yishou.com/project/128/interface/api/cat_3350)
 * @标签 `爆版4.28.0`
 * @请求头 `POST /baob/SupplyNotice/getWaitDealList`
 */
export const getWaitDealList = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getWaitDealListRequestConfig, requestData), ...args);
};
getWaitDealList.requestConfig = getWaitDealListRequestConfig;
/**
 * 接口 [前置仓邀约池规则配置 导出↗](http://yapi.yishou.com/project/128/interface/api/38545) 的 **请求配置**
 *
 * @分类 [前置仓邀约池↗](http://yapi.yishou.com/project/128/interface/api/cat_3350)
 * @请求头 `POST /erp/Supply/exportInvitationRule`
 */
const exportInvitationRuleRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Supply/exportInvitationRule",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: { type: "object", required: [], properties: {} },
    responseDataJsonSchema: { type: "object", properties: { file: { type: "string" } } },
    requestFunctionName: "exportInvitationRule",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [前置仓邀约池规则配置 导出↗](http://yapi.yishou.com/project/128/interface/api/38545) 的 **请求函数**
 *
 * @分类 [前置仓邀约池↗](http://yapi.yishou.com/project/128/interface/api/cat_3350)
 * @请求头 `POST /erp/Supply/exportInvitationRule`
 */
export const exportInvitationRule = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(exportInvitationRuleRequestConfig, requestData), ...args);
};
exportInvitationRule.requestConfig = exportInvitationRuleRequestConfig;
/**
 * 接口 [前置仓邀约池规则配置 导入↗](http://yapi.yishou.com/project/128/interface/api/38547) 的 **请求配置**
 *
 * @分类 [前置仓邀约池↗](http://yapi.yishou.com/project/128/interface/api/cat_3350)
 * @请求头 `POST /erp/Supply/importInvitationRule`
 */
const importInvitationRuleRequestConfig = /*#__PURE__*/ {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/Supply/importInvitationRule",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["file"],
        properties: { file: { type: "string", description: "文件" } },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "importInvitationRule",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [前置仓邀约池规则配置 导入↗](http://yapi.yishou.com/project/128/interface/api/38547) 的 **请求函数**
 *
 * @分类 [前置仓邀约池↗](http://yapi.yishou.com/project/128/interface/api/cat_3350)
 * @请求头 `POST /erp/Supply/importInvitationRule`
 */
export const importInvitationRule = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(importInvitationRuleRequestConfig, requestData), ...args);
};
importInvitationRule.requestConfig = importInvitationRuleRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/controller/invitationPool3350.js